export default "__VITE_PUBLIC_ASSET__4a96f480__"